<template>
    <stats-card
            :title="outstandingFormatted"
            sub-title="Oustanding Balance"
            type="primary"
            icon="fal fa-money-bill-alt"
    >
        <div slot="footer">
            <font-awesome-icon :icon="['fal','redo']" spin v-bind:spin=isLoading></font-awesome-icon>
            Update Now
        </div>
    </stats-card>
</template>

<script>
    import StatsCard from '../../components/Cards/StatsCard';

    export default {
        components: {
            StatsCard
        },
        name: "BillingBalanceCard",
        data() {
            return {
                outstanding: 0,
                isLoading: false,
            };
        },
        computed: {
            outstandingFormatted: function () {
                return this.outstanding + ' ' + this.$store.getters['customer/currency'];
            }
        },
        mounted() {
            this.isLoading = true;
            this.$store.dispatch('billing/loadOutstanding').then(() => {
                this.outstanding = this.$store.getters['billing/outstanding'];
                this.isLoading = false;
            });
        }
    }
</script>

<style scoped>

</style>